import productDetailsModal from './productDetailsModal';

export default productDetailsModal;
